
export const setFirstTimeLoad = ({ commit }, obj ) => {
  commit('FIRST_TIME_LOAD', obj)
}

export const setContactDetailsForTab = ({ commit }, obj ) => {
  commit('CONTACT_DETAILS_FOR_TAB', obj)
}

export const setContactHistorForTab = ({ commit }, obj ) => {
  commit('CONTACT_HISTORY_FOR_TAB', obj)
}

export const setMainListSavedFilter = ({ commit }, obj ) => {
  commit('MAIN_LIST_SAVED_FILTER', obj)
}

export const setMainListQuickFilters = ({ commit }, obj ) => {
  commit('MAIN_LIST_QUICK_FILTER', obj)
}

export const setQuickFiltersDatesFrom = ({ commit }, obj ) => {
  commit('QUICK_FILTERS_DATES_FROM', obj)
}

export const setQuickFiltersDatesTo = ({ commit }, obj ) => {
  commit('QUICK_FILTERS_DATES_TO', obj)
}

export const setSort = ({ commit }, { sortField, sortFieldId, sortOrder }) => {
  if (sortOrder >= -1 && sortOrder <= 1) {
    commit('SORT', { sortField, sortFieldId, sortOrder })
  }
}

export const setPage = ({ commit }, { page, rows }) => {
  commit('PAGE', { page, rows })
}

export const addHardLoad = ({ commit, getters }) => {
  let a = getters.getHardLoad
  commit('HARD_LOAD', a+=1)
}

export const addSoftReload = ({ commit, getters }) => {
  let a = getters.getSoftReload
  commit('SOFT_RELOAD', a+=1)
}